export var Direction;
(function (Direction) {
    Direction["VERTICAL"] = "vertical";
    Direction["HORIZONTAL"] = "horizontal";
})(Direction || (Direction = {}));
export var TreeLinkStyle;
(function (TreeLinkStyle) {
    TreeLinkStyle["CURVE"] = "curve";
    TreeLinkStyle["STRAIGHT"] = "straight";
})(TreeLinkStyle || (TreeLinkStyle = {}));
